import { render, staticRenderFns } from "./CreditsInput.vue?vue&type=template&id=57fd6882&"
import script from "./CreditsInput.vue?vue&type=script&lang=js&"
export * from "./CreditsInput.vue?vue&type=script&lang=js&"
import style0 from "./CreditsInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports